<template>
  <div>
    <div v-if="modelValue?.additionalEfforts !== undefined">
      <label class="core-form-label w-full">{{ wt('effort', 'additionalEffortLabel') }}</label>
      <div class="flex items-center">
        <NumberInput
          v-model="modelValue.additionalEfforts"
          :formatBigNumber="true"
          @keyup="forceNonEmptyValue(modelValue.additionalEfforts)"
          :class="{
            'core-form-error': validator.getErrors(`${formErrorPrefix}.additionalEfforts`),
          }"
          class="mb-0" />
        <div class="ml-3 w-24 text-neutral-550">{{ $t('general.hour') }}</div>
      </div>
      <ErrorMessage :name="`${formErrorPrefix}.additionalEfforts`" class="error-message" />
    </div>
    <div v-if="modelValue?.remarks !== undefined">
      <textarea
        class="core-form-textarea"
        id="description"
        placeholder="..."
        v-model.lazy="modelValue.remarks"
        rows="5"
        cols="50"
        :class="{
          'core-form-error': validator.getErrors(`${formErrorPrefix}.remarks`),
        }" />
      <ErrorMessage :name="`${formErrorPrefix}.remarks`" class="error-message" />
    </div>
  </div>
</template>

<script setup lang="ts">
import NumberInput from '@/components/partials/inputs/NumberInput.vue'
import ErrorMessage from '@/components/shared/ErrorMessage.vue'
import { useValidator } from '@/validation/form-validator'
import { toRef, type PropType } from 'vue'
import type { ProjectSubPhase } from '@/types'
import { useWidgetText } from '@/helpers/useWidgetText'

const modelValue = defineModel({ type: Object as PropType<ProjectSubPhase> })
const props = defineProps<{ formErrorPrefix: string; role?: string }>()
const { wt } = useWidgetText('widget-texts-project-service', toRef(props, 'role'))
const validator = useValidator()

const forceNonEmptyValue = function (value: number): void {
  if (modelValue?.value?.additionalEfforts) {
    modelValue.value.additionalEfforts = value || 0
  }
}
</script>

<style scoped></style>
